/* ══════════════════════════════════════
   JilbabCo Reviews — jcg-reviews.js
   Fetches reviews from AWS API proxy, renders in JilbabCo design
══════════════════════════════════════ */
(function () {
  'use strict';

  var API_BASE = 'https://api.jilbabco.com/api/reviews';
  var PER_PAGE = 5;
  var CLAMP_CHARS = 280;

  var allReviews = [];
  var filteredReviews = [];
  var currentPage = 1;
  var currentSort = 'newest';
  var currentFilter = 0;
  var reviewAvg = 0;
  var reviewCount = 0;

  var section, listEl, paginationEl, summaryEl, toolbarEl, loadingEl, emptyEl, lightboxEl;

  var initialized = false;

  function init() {
    section = document.getElementById('jcr-section');
    if (!section) return;
    if (initialized) return;
    initialized = true;

    listEl = section.querySelector('.jcr-list');
    paginationEl = section.querySelector('.jcr-pagination');
    summaryEl = section.querySelector('.jcr-summary');
    toolbarEl = section.querySelector('.jcr-toolbar');
    loadingEl = section.querySelector('.jcr-loading');
    emptyEl = section.querySelector('.jcr-empty');
    lightboxEl = section.querySelector('.jcr-lightbox');

    var productId = section.getAttribute('data-product-id');
    if (!productId) { showEmpty(); return; }

    fetchReviews(productId);
  }

  /* ══════════════════════════════════════
     FETCH REVIEWS FROM API
  ══════════════════════════════════════ */
  function fetchReviews(productId) {
    fetch(API_BASE + '?external_id=' + encodeURIComponent(productId))
      .then(function (res) {
        if (!res.ok) throw new Error('HTTP ' + res.status);
        return res.json();
      })
      .then(function (data) {
        var reviews = data.reviews || [];
        if (reviews.length === 0) { showEmpty(); return; }

        allReviews = reviews.map(function (r) {
          return {
            author: r.reviewer && r.reviewer.name ? r.reviewer.name : 'Anonymous',
            rating: r.rating || 5,
            date: formatDate(r.created_at),
            dateRaw: r.created_at || '',
            verified: r.verified === 'verified-purchase',
            source: r.source || null,
            pinned: r.pinned || false,
            title: r.title || '',
            body: r.body || '',
            bodyText: stripHTML(r.body || ''),
            photos: (r.pictures || []).map(function (p) {
              if (!p.urls) return '';
              return p.urls.original || p.urls.huge || p.urls.compact || '';
            }).filter(Boolean),
            reply: r.public_reply || r.admin_reply || ''
          };
        });

        var sum = allReviews.reduce(function (s, r) { return s + r.rating; }, 0);
        reviewAvg = sum / allReviews.length;
        reviewCount = allReviews.length;

        applySortAndFilter();
        renderSummary();
        renderToolbar();
        hideLoading();
        render();
      })
      .catch(function () {
        showEmpty();
      });
  }

  /* ══════════════════════════════════════
     SORT & FILTER
  ══════════════════════════════════════ */
  function applySortAndFilter() {
    filteredReviews = currentFilter === 0
      ? allReviews.slice()
      : allReviews.filter(function (r) { return r.rating === currentFilter; });

    filteredReviews.sort(function (a, b) {
      // Pinned reviews always come first
      if (a.pinned !== b.pinned) return a.pinned ? -1 : 1;
      switch (currentSort) {
        case 'oldest': return parseDate(a.dateRaw) - parseDate(b.dateRaw);
        case 'highest': return b.rating - a.rating;
        case 'lowest': return a.rating - b.rating;
        default: return parseDate(b.dateRaw) - parseDate(a.dateRaw);
      }
    });
    currentPage = 1;
  }

  function parseDate(str) {
    if (!str) return 0;
    var d = new Date(str);
    return isNaN(d.getTime()) ? 0 : d.getTime();
  }

  /* ══════════════════════════════════════
     RENDER — Summary
  ══════════════════════════════════════ */
  function renderSummary() {
    if (!summaryEl || allReviews.length === 0) return;
    var avg = reviewAvg.toFixed(1);
    var avgRound = Math.round(reviewAvg);

    summaryEl.innerHTML =
      '<div class="jcr-summary__avg">' + avg + '</div>' +
      '<div class="jcr-summary__detail">' +
        '<div class="jcr-summary__stars">' + starsHTML(avgRound) + '</div>' +
        '<div class="jcr-summary__count">Based on ' + reviewCount + ' review' + (reviewCount !== 1 ? 's' : '') + '</div>' +
      '</div>' +
      '<div class="jcr-summary__write">' +
        '<button class="jcr-btn" data-jcr-write>Write a Review</button>' +
      '</div>';

    summaryEl.querySelector('[data-jcr-write]').addEventListener('click', openWriteForm);
    summaryEl.style.display = '';
  }

  /* ══════════════════════════════════════
     RENDER — Toolbar
  ══════════════════════════════════════ */
  function renderToolbar() {
    if (!toolbarEl) return;
    var counts = [0, 0, 0, 0, 0, 0];
    allReviews.forEach(function (r) { counts[r.rating]++; });
    counts[0] = allReviews.length;

    var filtersHTML = '<button class="jcr-filter-btn is-active" data-jcr-filter="0">All (' + counts[0] + ')</button>';
    for (var i = 5; i >= 1; i--) {
      if (counts[i] > 0) {
        filtersHTML += '<button class="jcr-filter-btn" data-jcr-filter="' + i + '">' + i + '&#9733; (' + counts[i] + ')</button>';
      }
    }

    toolbarEl.innerHTML =
      '<div><span class="jcr-toolbar__label">Sort by </span>' +
        '<select class="jcr-toolbar__select" data-jcr-sort>' +
          '<option value="newest">Newest</option>' +
          '<option value="oldest">Oldest</option>' +
          '<option value="highest">Highest Rated</option>' +
          '<option value="lowest">Lowest Rated</option>' +
        '</select></div>' +
      '<div class="jcr-toolbar__filters">' + filtersHTML + '</div>';

    toolbarEl.querySelector('[data-jcr-sort]').addEventListener('change', function () {
      currentSort = this.value;
      applySortAndFilter();
      render();
    });

    toolbarEl.querySelectorAll('[data-jcr-filter]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        currentFilter = parseInt(this.getAttribute('data-jcr-filter'), 10);
        toolbarEl.querySelectorAll('[data-jcr-filter]').forEach(function (b) { b.classList.remove('is-active'); });
        this.classList.add('is-active');
        applySortAndFilter();
        render();
      });
    });

    toolbarEl.style.display = '';
  }

  /* ══════════════════════════════════════
     RENDER — Review list
  ══════════════════════════════════════ */
  function render() {
    if (!listEl) return;
    var start = (currentPage - 1) * PER_PAGE;
    var pageReviews = filteredReviews.slice(start, start + PER_PAGE);

    if (pageReviews.length === 0) {
      listEl.innerHTML = '<div class="jcr-empty"><p class="jcr-empty__text">No reviews match this filter.</p></div>';
      if (paginationEl) paginationEl.innerHTML = '';
      return;
    }

    var html = '';
    pageReviews.forEach(function (r) {
      var initials = getInitials(r.author);
      var needsClamp = r.bodyText.length > CLAMP_CHARS;
      var uid = 'jcr-' + Math.random().toString(36).substr(2, 6);

      html += '<li class="jcr-card">';
      html += '<div class="jcr-card__head">';
      html += '<div class="jcr-avatar">' + escapeHTML(initials) + '</div>';
      html += '<div class="jcr-card__meta">';
      html += '<div class="jcr-card__author">' + escapeHTML(r.author);
      if (r.source === 'shop-app') {
        html += '<span class="jcr-shop-badge">Verified by <strong>shop</strong></span>';
      } else if (r.verified) {
        html += '<span class="jcr-verified">Verified</span>';
      }
      html += '</div>';
      if (r.date) html += '<div class="jcr-card__date">' + escapeHTML(r.date) + '</div>';
      html += '</div></div>';
      html += '<div class="jcr-card__stars">' + starsHTML(r.rating) + '</div>';
      if (r.title) html += '<h3 class="jcr-card__title">' + escapeHTML(r.title) + '</h3>';
      html += '<div class="jcr-card__body' + (needsClamp ? ' is-clamped' : '') + '" id="' + uid + '">' + escapeHTML(r.body) + '</div>';
      if (needsClamp) html += '<button class="jcr-read-more" data-jcr-expand="' + uid + '">Read more</button>';

      if (r.photos.length > 0) {
        html += '<div class="jcr-card__photos">';
        r.photos.forEach(function (src) {
          html += '<div class="jcr-card__photo" data-jcr-lightbox="' + escapeAttr(src) + '"><img src="' + escapeAttr(src) + '" alt="Review photo" loading="lazy"></div>';
        });
        html += '</div>';
      }

      if (r.reply) {
        html += '<div class="jcr-reply">';
        html += '<div class="jcr-reply__label">Reply from JilbabCo</div>';
        html += '<div class="jcr-reply__body">' + escapeHTML(r.reply) + '</div>';
        html += '</div>';
      }

      html += '</li>';
    });

    listEl.innerHTML = html;

    listEl.querySelectorAll('[data-jcr-expand]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var target = document.getElementById(this.getAttribute('data-jcr-expand'));
        if (target) { target.classList.remove('is-clamped'); this.style.display = 'none'; }
      });
    });

    listEl.querySelectorAll('[data-jcr-lightbox]').forEach(function (thumb) {
      thumb.addEventListener('click', function () { openLightbox(this.getAttribute('data-jcr-lightbox')); });
    });

    renderPagination();
  }

  function renderPagination() {
    if (!paginationEl) return;
    var totalPages = Math.ceil(filteredReviews.length / PER_PAGE);
    if (totalPages <= 1) { paginationEl.innerHTML = ''; return; }

    var html = '<button class="jcr-page-btn" data-jcr-page="prev"' + (currentPage === 1 ? ' disabled' : '') + '>&lsaquo;</button>';
    for (var p = 1; p <= totalPages; p++) {
      html += '<button class="jcr-page-btn' + (p === currentPage ? ' is-active' : '') + '" data-jcr-page="' + p + '">' + p + '</button>';
    }
    html += '<button class="jcr-page-btn" data-jcr-page="next"' + (currentPage === totalPages ? ' disabled' : '') + '>&rsaquo;</button>';
    paginationEl.innerHTML = html;

    paginationEl.querySelectorAll('[data-jcr-page]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var val = this.getAttribute('data-jcr-page');
        var totalP = Math.ceil(filteredReviews.length / PER_PAGE);
        if (val === 'prev' && currentPage > 1) currentPage--;
        else if (val === 'next' && currentPage < totalP) currentPage++;
        else if (val !== 'prev' && val !== 'next') currentPage = parseInt(val, 10);
        render();
        scrollToSection();
      });
    });
  }

  /* ══════════════════════════════════════
     WRITE A REVIEW — Modal Form
  ══════════════════════════════════════ */
  var formModal = null;

  function openWriteForm() {
    if (!formModal) buildFormModal();
    formModal.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    // Reset form
    var form = formModal.querySelector('.jcr-form');
    if (form) form.reset();
    // Reset stars
    formModal.querySelectorAll('.jcr-form__star').forEach(function (s, i) {
      s.classList.toggle('jcr-star--empty', true);
    });
    formModal.querySelector('[data-jcr-form-rating]').value = '';
    var msg = formModal.querySelector('.jcr-form__msg');
    if (msg) { msg.textContent = ''; msg.className = 'jcr-form__msg'; }
    var submitBtn = formModal.querySelector('.jcr-form__submit');
    if (submitBtn) { submitBtn.disabled = true; submitBtn.textContent = 'Submit Review'; }
    validateForm();
  }

  function closeFormModal() {
    if (!formModal) return;
    formModal.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  function buildFormModal() {
    formModal = document.createElement('div');
    formModal.className = 'jcr-form-modal';
    formModal.innerHTML =
      '<div class="jcr-form-modal__overlay"></div>' +
      '<div class="jcr-form-modal__content">' +
        '<button class="jcr-form-modal__close" aria-label="Close">&times;</button>' +
        '<h3 class="jcr-form-modal__title">Write a Review</h3>' +
        '<form class="jcr-form" novalidate>' +
          '<div class="jcr-form__field">' +
            '<label class="jcr-form__label">Rating</label>' +
            '<div class="jcr-form__stars">' +
              '<span class="jcr-form__star jcr-star jcr-star--empty" data-jcr-star="1">&#9733;</span>' +
              '<span class="jcr-form__star jcr-star jcr-star--empty" data-jcr-star="2">&#9733;</span>' +
              '<span class="jcr-form__star jcr-star jcr-star--empty" data-jcr-star="3">&#9733;</span>' +
              '<span class="jcr-form__star jcr-star jcr-star--empty" data-jcr-star="4">&#9733;</span>' +
              '<span class="jcr-form__star jcr-star jcr-star--empty" data-jcr-star="5">&#9733;</span>' +
            '</div>' +
            '<input type="hidden" data-jcr-form-rating value="">' +
          '</div>' +
          '<div class="jcr-form__field">' +
            '<label class="jcr-form__label" for="jcr-name">Name</label>' +
            '<input class="jcr-form__input" type="text" id="jcr-name" name="name" required placeholder="Your name">' +
          '</div>' +
          '<div class="jcr-form__field">' +
            '<label class="jcr-form__label" for="jcr-email">Email</label>' +
            '<input class="jcr-form__input" type="email" id="jcr-email" name="email" required placeholder="your@email.com">' +
          '</div>' +
          '<div class="jcr-form__field">' +
            '<label class="jcr-form__label" for="jcr-title">Review Title <span class="jcr-form__optional">(optional)</span></label>' +
            '<input class="jcr-form__input" type="text" id="jcr-title" name="title" placeholder="Summarize your experience">' +
          '</div>' +
          '<div class="jcr-form__field">' +
            '<label class="jcr-form__label" for="jcr-body">Review</label>' +
            '<textarea class="jcr-form__textarea" id="jcr-body" name="review_body" required rows="4" placeholder="Share your experience with this product..."></textarea>' +
          '</div>' +
          '<div class="jcr-form__msg"></div>' +
          '<button type="submit" class="jcr-btn jcr-form__submit">Submit Review</button>' +
        '</form>' +
      '</div>';

    document.body.appendChild(formModal);

    // Star clicks handled via document delegation below

    // Live validation on input
    formModal.querySelectorAll('.jcr-form__input, .jcr-form__textarea').forEach(function (el) {
      el.addEventListener('input', validateForm);
    });

    // Close handlers
    formModal.querySelector('.jcr-form-modal__overlay').addEventListener('click', closeFormModal);
    formModal.querySelector('.jcr-form-modal__close').addEventListener('click', closeFormModal);

    // Submit handler
    formModal.querySelector('.jcr-form').addEventListener('submit', function (e) {
      e.preventDefault();
      submitReview();
    });
  }

  var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  function validateForm() {
    if (!formModal) return;
    var rating = formModal.querySelector('[data-jcr-form-rating]').value;
    var name = formModal.querySelector('#jcr-name').value.trim();
    var email = formModal.querySelector('#jcr-email').value.trim();
    var body = formModal.querySelector('#jcr-body').value.trim();
    var submitBtn = formModal.querySelector('.jcr-form__submit');
    if (!submitBtn) return;

    var valid = rating && name.length >= 2 && EMAIL_RE.test(email) && body.length > 0;
    submitBtn.disabled = !valid;
  }

  function submitReview() {
    var msg = formModal.querySelector('.jcr-form__msg');
    var submitBtn = formModal.querySelector('.jcr-form__submit');
    var rating = formModal.querySelector('[data-jcr-form-rating]').value;
    var name = formModal.querySelector('#jcr-name').value.trim();
    var email = formModal.querySelector('#jcr-email').value.trim();
    var title = formModal.querySelector('#jcr-title').value.trim();
    var body = formModal.querySelector('#jcr-body').value.trim();
    var productId = section.getAttribute('data-product-id');

    // Validate
    if (!rating) { showMsg(msg, 'Please select a star rating.', 'error'); return; }
    if (!name) { showMsg(msg, 'Please enter your name.', 'error'); return; }
    if (!email || email.indexOf('@') === -1) { showMsg(msg, 'Please enter a valid email.', 'error'); return; }
    if (!body) { showMsg(msg, 'Please write your review.', 'error'); return; }

    submitBtn.disabled = true;
    submitBtn.textContent = 'Submitting...';
    msg.textContent = '';

    fetch(API_BASE, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        name: name,
        email: email,
        rating: parseInt(rating, 10),
        title: title,
        review_body: body,
        product_id: productId
      })
    })
    .then(function (res) { return res.json(); })
    .then(function (data) {
      if (data.success) {
        showMsg(msg, 'Thank you! Your review has been submitted and will appear after approval.', 'success');
        submitBtn.textContent = 'Submitted';
      } else {
        showMsg(msg, data.error || 'Something went wrong. Please try again.', 'error');
        submitBtn.disabled = false;
        submitBtn.textContent = 'Submit Review';
      }
    })
    .catch(function () {
      showMsg(msg, 'Something went wrong. Please try again.', 'error');
      submitBtn.disabled = false;
      submitBtn.textContent = 'Submit Review';
    });
  }

  function showMsg(el, text, type) {
    el.textContent = text;
    el.className = 'jcr-form__msg jcr-form__msg--' + type;
  }

  /* ══════════════════════════════════════
     LIGHTBOX
  ══════════════════════════════════════ */
  function openLightbox(src) {
    if (!lightboxEl) return;
    lightboxEl.querySelector('.jcr-lightbox__img').src = src;
    lightboxEl.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }
  function closeLightbox() {
    if (!lightboxEl) return;
    lightboxEl.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  /* ══════════════════════════════════════
     HELPERS
  ══════════════════════════════════════ */
  function starsHTML(rating) {
    var html = '';
    for (var i = 1; i <= 5; i++) html += '<span class="jcr-star' + (i > rating ? ' jcr-star--empty' : '') + '">&#9733;</span>';
    return html;
  }
  function getInitials(name) {
    if (!name) return '?';
    var parts = name.trim().split(/\s+/);
    return parts.length >= 2 ? parts[0][0] + parts[parts.length - 1][0] : parts[0][0] || '?';
  }
  function escapeHTML(str) { var d = document.createElement('div'); d.textContent = str; return d.innerHTML; }
  function escapeAttr(str) { return str.replace(/&/g,'&amp;').replace(/"/g,'&quot;').replace(/'/g,'&#39;').replace(/</g,'&lt;').replace(/>/g,'&gt;'); }
  function stripHTML(str) { var d = document.createElement('div'); d.innerHTML = str; return d.textContent || ''; }
  function formatDate(iso) {
    if (!iso) return '';
    var d = new Date(iso);
    if (isNaN(d.getTime())) return '';
    var months = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
    return months[d.getMonth()] + ' ' + d.getDate() + ', ' + d.getFullYear();
  }
  function hideLoading() { if (loadingEl) loadingEl.style.display = 'none'; }
  function showEmpty() {
    hideLoading();
    if (emptyEl) emptyEl.style.display = '';
    if (summaryEl) summaryEl.style.display = 'none';
    if (toolbarEl) toolbarEl.style.display = 'none';
  }
  function scrollToSection() { if (section) section.scrollIntoView({ behavior: 'smooth', block: 'start' }); }

  /* -- Boot -- */
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  document.addEventListener('click', function (e) {
    // Write Review button (summary bar or empty state)
    if (e.target.closest('[data-jcr-write]')) openWriteForm();

    // Star rating click in form
    var starEl = e.target.closest('[data-jcr-star]');
    if (starEl && formModal) {
      var val = parseInt(starEl.getAttribute('data-jcr-star'), 10);
      formModal.querySelector('[data-jcr-form-rating]').value = val;
      formModal.querySelectorAll('.jcr-form__star').forEach(function (s) {
        var sv = parseInt(s.getAttribute('data-jcr-star'), 10);
        s.classList.toggle('jcr-star--empty', sv > val);
      });
      validateForm();
    }

    // Judge.me preview badge click → scroll to our reviews section
    var badge = e.target.closest('.jdgm-prev-badge, .jdgm-prev-badge__stars, .jdgm-prev-badge__text');
    if (badge) {
      e.preventDefault();
      e.stopPropagation();
      var target = document.getElementById('jcr-section');
      if (target) target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }

    // Lightbox
    if (e.target.closest('.jcr-lightbox__close') || (e.target.classList && e.target.classList.contains('jcr-lightbox'))) closeLightbox();
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') { closeLightbox(); closeFormModal(); } });
})();
